import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios'


class ReactUploadFile extends React.Component {
    constructor(props) {
        super(props);
        this.state ={file: '', msg:'If error occurs, please upload file manually',
					isSelected:false,Pro:[],user:localStorage.getItem('tokens')};
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
		this.handleChange=this.handleChange.bind(this);
    }
	
    onFormSubmit(e){		
        e.preventDefault();			
        const formData = new FormData();		
        formData.append('myImage',this.state.file);			
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        axios.post(process.env.REACT_APP_API_ENV+"api/uploadtxtfile.php",formData,config)
            .then((response) => {
				this.setState({msg:response.data});
            }).catch((error) => {
        });
    }
    onChange(e) {
        this.setState({file:e.target.files[0]});
		this.setState({isSelected:true});
    }
	handleChange = event => {					
		const {name, value} = event.target				
		this.setState({[name]: value})	
		this.setState({isSelected:false})
	}

    render() {
        return (
			<div style={{textAlign:'center'}}>
				<CommonHeader titles="Upload Returned Payment"/>			
				<form onSubmit={this.onFormSubmit}>          
					<h3>Choose Returnd File to Upload</h3>					
					<input type="file" name="file" style={{width:'160px'}} onChange= {this.onChange} /><br/><br/>	
					{this.state.isSelected ? (<div>
						<h2>Fiename:{this.state.file.name}</h2>
						<h2>Fietype:{this.state.file.type}</h2>
						<h2>Size in type:{this.state.file.size}</h2><br/><br/>					
					</div>):""}
					<h2>{this.state.msg}</h2><br/><br/>
					<input type="submit" name="submit" value="Upload" />					
				</form>
        </div>)
    }
}

export default ReactUploadFile

